
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy",
      function () {
        return require("private-next-pages/buy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy"])
      });
    }
  